import axiosInstance from "./axiosInstance";
import { getUserInfoDetails } from "../utlis";

// ============ Classes APIs ============

// Get all classes with pagination
export const getAllClasses = async (pageNum, pageSize) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.get(`/class?client=${clientId}&company=${companyId}&pageNum=${pageNum}&pageSize=${pageSize}`);
};

// Get a single class by ID
export const getClassById = async (classId) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.get(`/class/${classId}?client=${clientId}&company=${companyId}`);
};

// Create a new class
export const createClass = async (data) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.post(`/class?client=${clientId}&company=${companyId}`, data);
};

// Update an existing class
export const updateClass = async (classId, data) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.put(`/class/${classId}?client=${clientId}&company=${companyId}`, data);
};

// Delete a class
export const deleteClass = async (classId) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.delete(`/class/${classId}?client=${clientId}&company=${companyId}`);
};

// Legacy createClasses removed — use createClass() instead

// ============ Faculty APIs ============

// Get all faculty with pagination
export const getAllFaculty = async (pageNum, pageSize) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.get(`/faculty?client=${clientId}&company=${companyId}&pageNum=${pageNum}&pageSize=${pageSize}`);
};

// Get a single faculty by ID
export const getFacultyById = async (facultyId) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.get(`/faculty/${facultyId}?client=${clientId}&company=${companyId}`);
};

// Create a new faculty
export const createFaculty = async (data) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.post(`/faculty?client=${clientId}&company=${companyId}`, data);
};

// Update an existing faculty
export const updateFaculty = async (facultyId, data) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.put(`/faculty/${facultyId}?client=${clientId}&company=${companyId}`, data);
};

// Delete a faculty
export const deleteFaculty = async (facultyId) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.delete(`/faculty/${facultyId}?client=${clientId}&company=${companyId}`);
};

// ============ Training APIs ============

// Get all trainings with pagination
export const getAllTrainings = async (pageNum, pageSize) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.get(`/training?client=${clientId}&company=${companyId}&pageNum=${pageNum}&pageSize=${pageSize}`);
};

// Get a single training by ID
export const getTrainingById = async (recordId) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.get(`/training/${recordId}?client=${clientId}&company=${companyId}`);
};

// Create a new training
export const createTraining = async (data) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.post(`/training?client=${clientId}&company=${companyId}`, data);
};

// Update an existing training
export const updateTraining = async (recordId, data) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.put(`/training/${recordId}?client=${clientId}&company=${companyId}`, data);
};

// Delete a training
export const deleteTraining = async (recordId) => {
  const { clientId, companyId } = getUserInfoDetails();
  return axiosInstance.delete(`/training/${recordId}?client=${clientId}&company=${companyId}`);
};
